import { useLayoutEffect, useState } from 'react';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface SidebarState {
  collapsed: boolean;
  /** Телефон: открыт лист «Ещё» над панелью вкладок (2026-10-23, вместо выдвижного меню). */
  moreOpen: boolean;
  toggleCollapsed: () => void;
  setCollapsed: (v: boolean) => void;
  setMoreOpen: (v: boolean) => void;
}

export const useSidebarStore = create<SidebarState>()(
  persist(
    (set) => ({
      collapsed: false,
      moreOpen: false,
      toggleCollapsed: () => set((s) => ({ collapsed: !s.collapsed })),
      setCollapsed: (v) => set({ collapsed: v }),
      setMoreOpen: (v) => set({ moreOpen: v }),
    }),
    {
      name: 'lomora-sb',
      partialize: (s) => ({ collapsed: s.collapsed }),
    },
  ),
);

export function useIsSidebarMobile(): boolean {
  // Сразу верное значение: иначе первый кадр на телефоне рисовался компьютерной раскладкой
  // (на главной — монтировалась и тут же снималась строка создания).
  const [isMobile, setIsMobile] = useState(() => typeof window !== 'undefined' && window.innerWidth <= 900);
  useLayoutEffect(() => {
    const check = () => setIsMobile(window.innerWidth <= 900);
    check();
    window.addEventListener('resize', check);
    return () => window.removeEventListener('resize', check);
  }, []);
  return isMobile;
}
